<div class="flex flex-col justify-center space-y-4 items-center">
    <div *ngIf="type != 'none'" class="flex justify-center items-center p-2 rounded-full w-10 min-w-10 h-10 min-h-10" [ngClass]="{
        'bg-success': type === 'success',
        'bg-warning': type === 'warning',
        'bg-error': type === 'error',
        'bg-primary': type === 'info',
        'bg-primary-black': type === 'default'
    }">
        <ng-icon [name]="iconName" class="text-2xl text-white"></ng-icon>
    </div>
    <h1 *ngIf="title" class="text-center">
        {{ title | translate }}
    </h1>
</div>
<h3 *ngIf="subtitle" class="mt-6 text-center">{{ subtitle | translate }}</h3>
<div *ngIf="textContent" class="mt-6 text-center">{{ textContent | translate }}</div>